import React, { useState, useEffect } from "react";
import { Button, Spinner } from "react-bootstrap";
import { COLORS, DEFAULT_FILTERS, FilterState } from "../../types/profession.types";
import { useProfessions } from "../../hooks/useProfessions";
import { FilterBar } from "./FilterBar";
import { PricingTable } from "./PricingTable";

export const ProfessionPricingTab: React.FC = () => {
  const {
    professions,
    filteredProfessions,
    loading,
    savingId,
    edits,
    setEdits,
    fetchProfessions,
    handleSave,
    handleDelete,  // C'est une fonction qui prend (id, name)
    applyFilters,
  } = useProfessions();

  const [showFilters, setShowFilters] = useState(false);
  const [filters, setFilters] = useState<FilterState>(DEFAULT_FILTERS);

  useEffect(() => {
    applyFilters(filters);
  }, [filters, professions, applyFilters]);

  const handleFilterChange = (key: keyof FilterState, value: string) => {
    setFilters(prev => ({ ...prev, [key]: value }));
  };

  const resetFilters = () => {
    setFilters(DEFAULT_FILTERS);
  };

  const handleEdit = (professionId: number, field: string, value: any) => {
    setEdits(prev => ({
      ...prev,
      [professionId]: { ...prev[professionId], [field]: value }
    }));
  };

  // Adapter la fonction de suppression pour correspondre à l'interface attendue
  const handleDeleteWrapper = (profession: any) => {
    handleDelete(profession.id, profession.name);
  };

  if (loading && professions.length === 0) {
    return (
      <div className="text-center py-5">
        <Spinner animation="border" style={{ color: COLORS.primary }} />
        <p className="mt-3" style={{ color: COLORS.textLight }}>Chargement...</p>
      </div>
    );
  }

  return (
    <div>
      <FilterBar
        filters={filters}
        onFilterChange={handleFilterChange}
        onReset={resetFilters}
        showFilters={showFilters}
        onToggleFilters={() => setShowFilters(!showFilters)}
        totalCount={professions.length}
        filteredCount={filteredProfessions.length}
      />

      <PricingTable
        professions={filteredProfessions}
        edits={edits}
        savingId={savingId}
        onEdit={handleEdit}
        onSave={handleSave}
        onDelete={handleDeleteWrapper}  // Utiliser la fonction wrapper
      />

      {/* Message d'aide pour mobile */}
      <div className="d-block d-sm-none mt-3 p-3 text-center" style={{ backgroundColor: COLORS.light, borderRadius: "8px" }}>
        <small className="text-muted">
          <span style={{ marginRight: '4px' }}>📱</span>
          Faites défiler horizontalement pour voir toutes les colonnes
        </small>
      </div>

      {/* Pied de tableau */}
      <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center mt-4 gap-2">
        <div className="small text-muted">
          Affichage de {filteredProfessions.length} profession(s) sur {professions.length} au total
        </div>
        <Button
          variant="link"
          onClick={fetchProfessions}
          className="text-decoration-none"
          style={{ color: COLORS.textLight }}
        >
          ↻ Actualiser
        </Button>
      </div>
    </div>
  );
};